module.exports = __webpack_public_path__ + "img/WechatIMG25.51a7e997.png";